import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';
import { SocketService } from '@services/webFeeder/socket.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { MessageParameterNegotiation } from '@model/webFeeder/message-parameter-negotiation.model';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { MarketEnum } from '@model/enum/market.enum';
import { Constants } from '@utils/constants';
import { Observable , of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialComplService {
  messages: Observable<any>;
  private serviceSubject = new Subject<MessageEvent>();
  public snapCache: any = [];
  public listComponentSubscribe = [];

  constructor(
    private socketService: SocketService,
    private configService: ConfigService
  ) { }

  public createSubject() {
    const newService = {
      name: 'FinancialComplSvcByFn',
      serviceSubject: this.serviceSubject,
      fn: (data) => {
        let isFinancialCompl = false;
        if (data && data.financialInformationBean && data.financialInformationBean.length > 0) {
          // data.financialInformationBean.forEach(element => {
          // if (element.finalMarkToMarketAmount || element.incrementalMarkToMarketAmount) {
          isFinancialCompl = true;
          // }
          // });
        }
        return isFinancialCompl;
      }
    };
    this.socketService.register(newService);
    this.messages = newService.serviceSubject.pipe(map(data => {
      this.snapCachePosition(data);
      return data;
    }));
  }

  snapCachePosition(message?: any) {
    if (this.snapCache.length > 0) {
      let indexTemp;
      let posTemp;
      if (message) {
        message.forEach(element => {
          this.snapCache.find((x, index) => {
            if (x.account.toUpperCase() === element.account.toUpperCase()) {
              indexTemp = index;
              posTemp = element;
            }
          });
          if (posTemp && indexTemp >= 0) {
            this.snapCache[indexTemp] = posTemp;
            posTemp = null;
            indexTemp = null;
          } else {
            this.snapCache.push(element);
          }
        });
      }
    } else {
      this.snapCache = message;
    }
    return this.snapCache;
  }

  public unsubscribeFinancial(account: string, componentName: string) {
    this.listComponentSubscribe = this.checkListSubscribeComponent(false, this.listComponentSubscribe, componentName);
    if (this.listComponentSubscribe.length < 1) {
      this.sendMessageFinancial(account, MarketEnum.BOVESPA, false);
    }
    this.configService.writeLog('UNSUBSCRIBE FINANCIAL COMPL > [' + this.listComponentSubscribe.length + '][' + account + ']['
      + (componentName ? componentName.toUpperCase() : null) + '] <<<<<');
  }

  public subscribeFinancial(account: string, componentName: string) {
    this.listComponentSubscribe = this.checkListSubscribeComponent(true, this.listComponentSubscribe, componentName);
    if (this.listComponentSubscribe.length <= 1) {
      this.sendMessageFinancial(account, MarketEnum.BOVESPA, true);
    }
    this.configService.writeLog('SUBSCRIBE FINANCIAL COMPL > [' + this.listComponentSubscribe.length + '][' + account + ']['
      + (componentName ? componentName.toUpperCase() : null) + '] <<<<<');
  }

  public checkListSubscribeComponent(isSubscribe: boolean, listComponent: any, componentName: string) {
    if (componentName && componentName !== '' && componentName !== undefined) {
      componentName = componentName.trim().toLowerCase();
      if (listComponent && isSubscribe && listComponent.length === 0) {
        listComponent.push({ componentName: componentName });
      } else if (listComponent && listComponent.length > 0) {
        const component = listComponent.find((element) => element.componentName === componentName);
        if (!component && isSubscribe) {
          listComponent.push({ componentName: componentName });
        } else if (component && !isSubscribe) {
          const index = listComponent.indexOf(componentName);
          listComponent.splice(index, 1);
        }
      }
    }
    return listComponent;
  }

  private sendMessageFinancial(account: string, market: MarketEnum, dispatch: boolean) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'negotiation';
    dataMsg.service = 'financialAccountInformationCompl';
    const messageParameter = new MessageParameterNegotiation();
    messageParameter.account = account;
    messageParameter.market =
      market === MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF;
    messageParameter.dispatch = dispatch;
    messageParameter.history = true;
    dataMsg.parameters = messageParameter;
    if (market !== undefined) {
      setTimeout(() => {
        this.socketService.signService(dataMsg);
      }, 1000);
    }
  }
}
